module.exports = __webpack_public_path__ + "static/media/communityroll.d5510066.webp";